import { atom } from "jotai";
import { atomFamily, atomWithStorage } from "jotai/utils";

export const activeEntityIdAtom = atom<string>("");

export const isCreateObjectiveModalOpenAtom = atom<boolean>(false);

export const selectedSubthemesAtomFamily = atomFamily(
    (orgUname: string | undefined) =>
        atomWithStorage<(string | null)[]>(
            `objectivesSelectedSubthemes_${orgUname}`,
            [],
        ),
);

export const selectedUsersAtomFamily = atomFamily(
    (orgUname: string | undefined) =>
        atomWithStorage<(string | null)[]>(
            `objectivesSelectedUsers_${orgUname}`,
            [],
        ),
);

export const selectedThemesAtomFamily = atomFamily(
    (orgUname: string | undefined) =>
        atomWithStorage<(string | null)[]>(
            `objectivesSelectedThemes_${orgUname}`,
            [],
        ),
);
